import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createPersistentStorage } from '../../../lib/persistentStorage'
import type { RegistrationDraft, SegmentId } from './types'

export interface RegistrationAttempt {
  id: string
  segment: SegmentId
  draft: RegistrationDraft | null
  createdUserId: string | null
}
interface AttemptState { attempt: RegistrationAttempt | null; boundAttempt: RegistrationAttempt | null }
export const useRegistrationAttempt = create<AttemptState>()(
  persist<AttemptState>(() => ({ attempt: null, boundAttempt: null }), { name: 'humanteq-registration-attempt', storage: createPersistentStorage() }),
)
export function beginRegistrationAttempt(segment: SegmentId, draft: RegistrationDraft | null = null) {
  const attempt: RegistrationAttempt = {
    id: crypto.randomUUID(), segment,
    draft: draft?.segment === segment ? structuredClone(draft) : null,
    createdUserId: null,
  }
  useRegistrationAttempt.setState({ attempt })
  return attempt
}
export function recordCreatedAccount(attemptId: string, userId: string | null | undefined) {
  const { attempt } = useRegistrationAttempt.getState()
  if (attempt?.id === attemptId) {
    useRegistrationAttempt.setState(userId ? { attempt: { ...attempt, createdUserId: userId }, boundAttempt: { ...attempt, createdUserId: userId } } : { attempt: null })
  }
}
export function clearRegistrationAttempt() { useRegistrationAttempt.setState({ attempt: null, boundAttempt: null }) }
export function registrationForUser(userId: string) {
  const { attempt, boundAttempt } = useRegistrationAttempt.getState()
  if (boundAttempt?.createdUserId === userId) return boundAttempt
  return attempt?.createdUserId === userId ? attempt : null
}
